import React from "react";
import FoldersEditPage from "../../components/folders/edit";
import { createFolders, updateFolder } from "../../store/actions/folders";
import {
  loadFolderDetail,
  loadFolderDetailContent
} from "../../store/actions/folders/detail";
import { getSettingsCompany, savePermissions } from "../../store/actions/permissions";
import { getDocumentsWithSearch } from "../../store/actions/documentsWithSearch";
import { FormattedMessage } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import Page from "../../components/general/page";
import { useLocation, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

const FoldersEditView = props => {
  const {    
    pageRef
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const folders = useSelector(state => state.folders);
  const foldersDetail = useSelector(state => state.foldersDetail);
  const isLoadingPreview = useSelector(state => state.foldersDetail.isLoadingPreview);

  const intl = useIntl();

  const [searchPage, setSearchPage] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [resultSaveEdit, setResutlSaveEdit] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    dispatch(getDocumentsWithSearch(null,
      ""));
  }, []);

  const getFolderById = async folderId => {
    setIsEditing(true);
    dispatch(loadFolderDetail(folderId));
  };

  const getFolderDocuments = async folderId => {
    dispatch(loadFolderDetailContent(folderId));
  };

  const onSave = async requestBody => {
    // Se prima del salvataggio non ho nessun fascicolo, vuol dire che sto salvando il primo quindi devo dare il permesso al cliente per vederlo
    if (!folders || !folders.folders || folders.folders.length === 0) {
      let settingsToSave = [
        {
          ownerId: main.accountantUuidSelected ? main.accountantUuidSelected : "",
          userId: null,
          permissions: [
            {
              itemId: main.companyUuidSelected,
              userId: null,
              actions: [
                {
                  name: "attivitaFascicoli",
                  isActive: true
                }
              ]
            }
          ]
        }
      ];
      dispatch(savePermissions(settingsToSave,
        main.companyUuidSelected)).then(res => {
        dispatch(getSettingsCompany());
      });
    }
    await
    dispatch(createFolders(requestBody)).then(res => {
      setResutlSaveEdit(true);
    });
  };

  const onUpdate = async(folderId, requestBody) => {
    await dispatch(updateFolder(folderId,
      requestBody)).then(res => {
      setResutlSaveEdit(true);
    });
  };

  const selectedCompanyName = company?.companies?.find(el => el.id === main.clientIdSelected);

  return (
    <Page
      pageRef={pageRef}
      activePage="/folders"
      className="contentStructure transparent settings"      
      title={
        isEditing ? (
          <FormattedMessage id="folders.edit" />
        ) : (
          <FormattedMessage id="folders.create" />
        )
      }
      subtitle={
        selectedCompanyName?.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
      }
      backText={<FormattedMessage id="folders.backTo" />}
      backUrl="/folders"
    >
      <FoldersEditPage
        {...props}
        auth={auth}
        location={location}
        navigate={navigate}
        onSave={onSave}
        onUpdate={onUpdate}
        searchPage={searchPage}
        onSearchResultsBack={() => setSearchPage(1)}
        searchDialogPage={page => setSearchPage(page)}
        hasMoreItems={false}
        resultsSize={20}
        isEditing={isEditing}
        getFolderDocuments={getFolderDocuments}
        getFolderById={getFolderById}
        foldersDetail={foldersDetail}
        folders={folders}
        isLoadingPreview={isLoadingPreview}
        result={resultSaveEdit}
        selectedCompanyName={selectedCompanyName}
        intl={intl}
      />
    </Page>
  );
};

export default FoldersEditView;
